/* ══════════════════════════════════════════════════════════════════
   [D-767] «👆 Хто переходив у наші застосунки» — на сторінці «Наші APP».

   OWNER 29.10: «Зайшов новий юзер а в дашборді чомусь нічого не показує».
   Нічого не було зламано: подія записувалась, API її віддавав, і картка
   того партнера її показувала. Але знайти її можна було, лише ЗНАЮЧИ
   наперед, чий це учень, — а бот у повідомленні називає ЗАСТОСУНОК, не
   партнера. Тому перелік тепер є там, куди веде саме повідомлення.

   🔴 І головне: показ був прив'язаний до партнера, тож людину без партнера
   не було видно ніде. На момент правки таких переходів 7 із 17.

   [D-769] OWNER 30.10: «зроби картку-зведення "звідки приходять"». Окремий
   ряд карток угорі: скільки переходів і скільки людей дає кожен шлях.
   Картка — ще й перемикач: обрав джерело — і ВСЕ нижче рахується від нього
   (застосунки, люди, їхні значки). Без цього «зведення» було б красивим
   числом, яке нікуди не веде: побачив «з презентації 12» і знов шукаєш
   руками, хто ж то був.
   ══════════════════════════════════════════════════════════════════ */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';   // [D-768] звідси - в картку людини
import { Box, Typography, Button } from '@mui/material';
import api from '../api';
import { srcLine, srcLabel } from './appClickSrc';   // [D-768] «📍 Звідки»

const C = { card2: '#1b2836', line: 'rgba(0,229,160,.22)', txt: '#eaf6ff', dim: '#a8bece',
            neon: '#00e5a0', warn: '#ffb74d', blue: '#4fc3f7', grey: '#90a4ae' };
const grid = (min) => ({ display: 'grid', gap: 1.2, gridTemplateColumns: `repeat(auto-fill, minmax(${min}px, 1fr))` });
const fdt = (v) => (v ? new Date(v).toLocaleString('uk-UA', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');
const PERIODS = [[7, '7 днів'], [30, '30 днів'], [90, '90 днів'], [0, 'увесь час']];
// Колір рамки каже, хто це, ще до читання підпису: сам партнер, його учень,
// або людина, яка не належить нікому — саме таких раніше не було видно.
const RC = { partner: '#ffb74d', student: '#4fc3f7', none: '#90a4ae' };
const RT = { partner: '🧑‍💼 сам партнер', student: '👤 учень', none: '🙋 без партнера' };
const Z = { open: 0, preview: 0 };
// 1 перехід · 2-4 переходи · 5+ переходів (11-14 - теж «переходів»)
const wClicks = (n) => {
  const a = n % 10, b = n % 100;
  return (a === 1 && b !== 11) ? 'перехід' : ((a >= 2 && a <= 4 && (b < 12 || b > 14)) ? 'переходи' : 'переходів');
};
const nClicks = (n) => n + ' ' + wClicks(n);
// 1 раз · 2-4 рази · 5+ разів
const wTimes = (n) => {
  const a = n % 10, b = n % 100;
  return (a === 1 && b !== 11) ? 'раз' : ((a >= 2 && a <= 4 && (b < 12 || b > 14)) ? 'рази' : 'разів');
};

export default function AppClicksAll() {
  const nav = useNavigate();
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [open, setOpen] = useState(true);
  const [srcF, setSrcF] = useState('');   // [D-769] обране джерело ('' - усі)
  useEffect(() => {
    let dead = false; setD(null); setErr(''); setSrcF('');
    api.get('/app-clicks', { params: { days } }).then(r => { if (!dead) setD(r.data); })
      .catch(e => { if (!dead) setErr((e && e.response && e.response.data && e.response.data.detail) || 'Не вдалося завантажити'); });
    return () => { dead = true; };
  }, [days]);
  const title = (k) => { const a = ((d && d.apps) || []).find(x => x.key === k); return a ? (a.icon || '📱') + ' ' + a.title : k; };
  // [D-769] коли обрано джерело — беремо його розріз; інакше загальні числа.
  const appN = (a) => (srcF ? (a.srcs && a.srcs[srcF]) || Z : { open: a.opens, preview: a.previews });
  const byN = (b) => (srcF ? (b.srcs && b.srcs[srcF]) || Z : b);
  return (
    <Box data-aca="page" sx={{ mb: 2.4, p: 1.6, borderRadius: 2, border: `1px solid ${C.line}`, bgcolor: 'rgba(0,229,160,.03)' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: open ? 1.4 : 0 }}>
        <Typography sx={{ color: C.txt, fontWeight: 800, fontSize: 15, flex: 1, minWidth: 220 }}>
          👆 Хто переходив у наші застосунки{d ? ` · ${d.total}` : ''}
        </Typography>
        {open && PERIODS.map(([n, t]) => (
          <Button key={n} size="small" data-aca-days={n} onClick={() => setDays(n)}
                  sx={{ textTransform: 'none', fontSize: 12.5, fontWeight: 700, minWidth: 0, px: 1.2, borderRadius: 2,
                        border: `1px solid ${days === n ? C.neon : 'rgba(255,255,255,.14)'}`,
                        color: days === n ? '#04121a' : C.txt, bgcolor: days === n ? C.neon : 'transparent',
                        '&:hover': { bgcolor: days === n ? C.neon : 'rgba(255,255,255,.06)' } }}>{t}</Button>
        ))}
        <Button size="small" data-aca="toggle" onClick={() => setOpen(!open)}
                sx={{ textTransform: 'none', fontSize: 12.5, color: C.dim, minWidth: 0 }}>{open ? 'згорнути' : 'розгорнути'}</Button>
      </Box>
      {open && (<>
        {err && <Typography sx={{ color: '#ff8a80', fontSize: 13 }}>{err}</Typography>}
        {!d && !err && <Typography sx={{ color: C.dim, fontSize: 13 }}>Завантаження…</Typography>}
        {d && (() => {
          const ppl = srcF ? d.people.filter(u => u.srcs && u.srcs[srcF]) : d.people;
          const apps = d.apps.filter(a => appN(a).open + appN(a).preview > 0);
          const shown = srcF ? (d.srcs[srcF] || 0) : d.total;
          const srcCards = Object.keys(d.srcs || {}).sort((a, b) => d.srcs[b] - d.srcs[a]);
          const usersOf = (key) => ppl.filter(u => u.by[key] && (!srcF || (u.by[key].srcs && u.by[key].srcs[srcF]))).length;
          return (<>
          <Typography data-aca="sum" sx={{ color: C.dim, fontSize: 12.5, mb: 1 }}>
            Переходів: <b style={{ color: C.txt }}>{d.total}</b> · людей: <b style={{ color: C.txt }}>{d.people.length}</b>
            {d.no_partner > 0 ? <> · з них <b style={{ color: C.txt }}>{d.no_partner}</b> не належать жодному партнерові</> : null}
          </Typography>
          {d.total === 0 && <Typography data-aca="empty" sx={{ color: C.dim, fontSize: 13.5, py: 1.5 }}>За цей період у ваші застосунки ніхто не переходив.</Typography>}
          {d.total > 0 && (<>
            {/* [D-769] «Звідки приходять» — зведення по шляхах. Кожна картка ще й перемикач. */}
            <Typography sx={{ color: C.txt, fontWeight: 700, fontSize: 13, mb: .8 }}>
              📍 Звідки приходять
              <span style={{ color: C.dim, fontWeight: 500 }}> — натисніть шлях, щоб лишити нижче тільки його</span>
            </Typography>
            <Box sx={{ ...grid(165), mb: 1.6 }}>
              {srcCards.map(k => {
                const n = d.srcs[k], on = srcF === k;
                const who = d.people.filter(u => u.srcs && u.srcs[k]).length;
                return (
                  <Box key={k || 'none'} data-aca-srccard={k || 'none'} onClick={() => setSrcF(on ? '' : k)}
                       sx={{ cursor: 'pointer', bgcolor: on ? 'rgba(0,229,160,.14)' : C.card2, borderRadius: 2.5, p: 1.2,
                             borderTop: `3px solid ${on ? C.neon : (k ? C.blue : C.grey)}`,
                             '&:hover': { bgcolor: on ? 'rgba(0,229,160,.18)' : '#223447' } }}>
                    <Typography sx={{ color: C.txt, fontWeight: 800, fontSize: 12.5, lineHeight: 1.25 }}>{srcLabel(k)}</Typography>
                    <Typography sx={{ color: on ? C.neon : C.txt, fontWeight: 900, fontSize: 21, lineHeight: 1.2 }}>
                      {n}<span style={{ fontSize: 12, color: C.dim, fontWeight: 600 }}> {wClicks(n)}</span></Typography>
                    <Typography sx={{ color: C.dim, fontSize: 12 }}>
                      {d.total ? Math.round((n * 100) / d.total) : 0}% · людей: {who}</Typography>
                  </Box>
                );
              })}
            </Box>
            {srcF && (
              <Box data-aca="srcnote" sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1.2, p: 1, borderRadius: 2,
                                           bgcolor: 'rgba(0,229,160,.07)', border: `1px dashed ${C.line}` }}>
                <Typography sx={{ color: C.txt, fontSize: 12.5, flex: 1, minWidth: 220 }}>
                  Нижче — тільки «{srcLabel(srcF)}»: <b>{nClicks(shown)}</b>, людей <b>{ppl.length}</b>.
                </Typography>
                <Button size="small" data-aca="srcall" onClick={() => setSrcF('')}
                        sx={{ textTransform: 'none', fontSize: 12.5, color: C.neon }}>показати всі шляхи</Button>
              </Box>
            )}
            <Typography sx={{ color: C.txt, fontWeight: 700, fontSize: 13, mb: .8 }}>
              📱 Застосунки<span style={{ color: C.dim, fontWeight: 500 }}> — скільки разів відкривали і скільки дивились презентацію</span>
            </Typography>
            <Box sx={{ ...grid(180), mb: 1.6 }}>
              {apps.map(a => {
                const x = appN(a);
                return (
                  <Box key={a.key} data-aca-app={a.key} sx={{ bgcolor: C.card2, borderRadius: 2.5, p: 1.2, borderTop: `3px solid ${C.neon}` }}>
                    <Typography sx={{ color: C.txt, fontWeight: 800, fontSize: 13.5 }}>{a.icon || '📱'} {a.title}</Typography>
                    <Typography sx={{ color: C.neon, fontWeight: 900, fontSize: 21, lineHeight: 1.2 }}>{x.open}<span style={{ fontSize: 12, color: C.dim, fontWeight: 600 }}> {wTimes(x.open)} відкрили</span></Typography>
                    <Typography sx={{ color: C.dim, fontSize: 12 }}>презентацію: {x.preview} · людей: {srcF ? usersOf(a.key) : a.users}</Typography>
                  </Box>
                );
              })}
            </Box>
            <Typography sx={{ color: C.txt, fontWeight: 700, fontSize: 13, mb: .8 }}>
              👥 Люди<span style={{ color: C.dim, fontWeight: 500 }}> — клік відкриває картку людини</span>
            </Typography>
            <Box sx={grid(250)}>
              {ppl.map(u => (
                // [D-768] клік - у картку цієї людини: шукати її руками не треба (а учня партнера в «Користувачах» і не знайти)
                <Box key={u.tg} data-aca-user={u.tg} data-aca-uid={u.uid || ''}
                     onClick={() => (u.uid ? nav('/users/' + u.uid) : null)}
                     sx={{ bgcolor: C.card2, borderRadius: 2.5, p: 1.2, borderTop: `3px solid ${RC[u.role] || C.grey}`,
                           cursor: u.uid ? 'pointer' : 'default', '&:hover': u.uid ? { bgcolor: '#223447' } : {} }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: .8 }}>
                    <Typography sx={{ color: C.txt, fontWeight: 800, fontSize: 13.5, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {u.username ? '@' + u.username : (u.name || 'id ' + u.tg)}</Typography>
                    <Box sx={{ px: .8, py: .1, borderRadius: 1, bgcolor: RC[u.role] || C.grey }}>
                      <Typography sx={{ fontSize: 10.5, fontWeight: 800, color: '#06120a' }}>{RT[u.role] || RT.none}</Typography></Box>
                  </Box>
                  <Typography sx={{ color: C.dim, fontSize: 12 }}>
                    id {u.tg}{u.who ? ' · ' + u.who : ''} · востаннє {fdt(u.last)}</Typography>
                  {/* [D-768] звідки прийшов: Хаб, смужка Студії чи презентація */}
                  {srcLine(u.srcs) ? <Typography data-aca-src={u.tg} sx={{ color: C.dim, fontSize: 11.5 }}>📍 {srcLine(u.srcs)}</Typography> : null}
                  <Typography sx={{ color: C.txt, fontSize: 13, fontWeight: 700, mt: .4 }}>
                    переходів: {srcF ? u.srcs[srcF] : u.total}{srcF ? <span style={{ color: C.dim, fontWeight: 500, fontSize: 12 }}> (звідси; усього {u.total})</span> : null}</Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .6, mt: .6 }}>
                    {Object.keys(u.by).filter(k => !srcF || (u.by[k].srcs && u.by[k].srcs[srcF])).map(k => {
                      const x = byN(u.by[k]);
                      return (
                        <Box key={k} sx={{ px: .9, py: .3, borderRadius: 1.5, border: '1px solid rgba(255,255,255,.14)' }}>
                          <Typography sx={{ fontSize: 12, color: C.txt }}>{title(k)}{x.open ? <b style={{ color: C.neon }}> ×{x.open}</b> : null}{x.preview ? <span style={{ color: C.dim }}> · 👁 {x.preview}</span> : null}</Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              ))}
            </Box>
            <Typography sx={{ color: C.dim, fontSize: 11.5, mt: 1.2 }}>
              🖱️ Клік на людину — її картка з усіма переходами. ×N — скільки разів відкрив застосунок; 👁 — скільки разів дивився презентацію; 📍 — звідки він туди перейшов
              (переходи до 30.10 джерела не мають — тоді його ще не записували). Ті самі події приходять у гілку «👆 Переходи в застосунки».
              Переходи лише учнів одного партнера — у його картці, вкладка «📲 Переходи в APP».
            </Typography>
          </>)}
          </>);
        })()}
      </>)}
    </Box>
  );
}
